import { useAuth } from '@gen2/hooks';
import { FC, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';

type ProtectedRouteProps = { children: ReactNode };

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const isPrequalComplete =
    user?.organisations?.[0]?.is_pre_qualification_completed;
  const isMfaSetupRequired = user?.mfa_setup_required;

  // todo: user's permissions
  if (!isAuthenticated && !user) {
    return <Navigate to="/login" replace />;
  }

  // If MFA setup is required, allow user to access user-settings for MFA setup
  if (isMfaSetupRequired && location.pathname !== '/user-settings') {
    return <Navigate to="/user-settings?tab=security" replace />;
  }

  // If pre-qualification is not complete, redirect to dashboard
  if (!isPrequalComplete && location.pathname !== '/dashboard') {
    return <Navigate to="/dashboard" replace />;
  }

  return children ? <> {children}</> : <Outlet />;
};

export default ProtectedRoute;
